/* Drawer Cart 6.0 (task 86c9ykbw3): timer "carrello riservato".
   Parte quando il drawer si apre, sopravvive ai ricaricamenti (sessionStorage),
   a zero si nasconde; alla riapertura successiva riparte. */
class CartReserveTimer extends HTMLElement {
  connectedCallback() {
    this.minutes = parseInt(this.dataset.minutes, 10) || 24;
    this.storageKey = 'ef-cart-reserve-deadline';
    this.output = this.querySelector('[data-timer-text]');
    this.drawer = this.closest('cart-drawer');
    this.onDrawerChange = this.onDrawerChange.bind(this);
    if (this.drawer) {
      this.observer = new MutationObserver(this.onDrawerChange);
      this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['active'] });
      if (this.drawer.hasAttribute('active')) this.start();
    } else {
      this.start();
    }
  }
  disconnectedCallback() {
    clearInterval(this.interval);
    if (this.observer) this.observer.disconnect();
  }
  onDrawerChange() {
    if (this.drawer.hasAttribute('active')) this.start();
  }
  readDeadline() {
    try { return parseInt(sessionStorage.getItem(this.storageKey), 10) || 0; } catch (e) { return this.deadline || 0; }
  }
  writeDeadline(value) {
    try { value ? sessionStorage.setItem(this.storageKey, String(value)) : sessionStorage.removeItem(this.storageKey); } catch (e) {}
  }
  start() {
    const now = Date.now();
    let deadline = this.readDeadline();
    if (!deadline || deadline <= now) {
      deadline = now + this.minutes * 60 * 1000;
      this.writeDeadline(deadline);
    }
    this.deadline = deadline;
    clearInterval(this.interval);
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }
  tick() {
    const left = this.deadline - Date.now();
    if (left <= 0) {
      clearInterval(this.interval);
      this.hidden = true;
      this.writeDeadline(0);
      return;
    }
    const m = Math.floor(left / 60000);
    const s = Math.floor((left % 60000) / 1000);
    if (this.output) this.output.textContent = `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    this.hidden = false;
  }
}
if (!customElements.get('cart-reserve-timer')) customElements.define('cart-reserve-timer', CartReserveTimer);
